import {
  GET_NOTIFICATIONS_REQUEST,
  GET_NOTIFICATIONS_SUCCESS,
  GET_NOTIFICATIONS_FAIL,
  MARK_NOTIFICATION_READ_SUCCESS,
  MARK_NOTIFICATION_READ_FAIL,
  DELETE_NOTIFICATION_SUCCESS,
  DELETE_NOTIFICATION_FAIL,
  MARK_ALL_NOTIFICATIONS_READ_SUCCESS,
  MARK_ALL_NOTIFICATIONS_READ_FAIL,
  GET_UNREAD_NOTIFICATIONS_COUNT_REQUEST,
  GET_UNREAD_NOTIFICATIONS_COUNT_SUCCESS,
  GET_UNREAD_NOTIFICATIONS_COUNT_FAIL,
} from '../actions/notifications';

import { LOGOUT, AUTH_ERROR } from '../actions/auth';

const initialState = {
  notifications: [],
  unreadCount: 0,
  error: null,
  loading: false,
};

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_NOTIFICATIONS_REQUEST:
      return { ...state, loading: true };
    case GET_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        notifications: action.payload,
        loading: false,
        error: null,
      };
    case GET_NOTIFICATIONS_FAIL:
      return { ...state, loading: false, error: action.payload };

    case MARK_NOTIFICATION_READ_SUCCESS:
      return {
        ...state,
        notifications: state.notifications.map((n) =>
          n.id === action.payload.id ? action.payload : n
        ),
        error: null,
      };
    case MARK_NOTIFICATION_READ_FAIL:
      return { ...state, error: action.payload };

    case DELETE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        notifications: state.notifications.filter(
          (n) => n.id !== action.payload
        ),
        error: null,
      };
    case DELETE_NOTIFICATION_FAIL:
      return { ...state, error: action.payload };

    case MARK_ALL_NOTIFICATIONS_READ_SUCCESS:
      return {
        ...state,
        notifications: state.notifications.map((n) => ({ ...n, read: true })),
        error: null,
      };
    case MARK_ALL_NOTIFICATIONS_READ_FAIL:
      return { ...state, error: action.payload };

    case GET_UNREAD_NOTIFICATIONS_COUNT_REQUEST:
      return { ...state, loading: true };
    case GET_UNREAD_NOTIFICATIONS_COUNT_SUCCESS:
      return {
        ...state,
        unreadCount: action.payload,
        loading: false,
        error: null,
      };
    case GET_UNREAD_NOTIFICATIONS_COUNT_FAIL:
      return { ...state, loading: false, error: action.payload };

    case LOGOUT:
    case AUTH_ERROR:
      return initialState;

    default:
      return state;
  }
};

export default notificationReducer;
